import { pipe } from 'rxjs';
import { selectLastTravel } from './last-travel.selector';
import { prop } from 'ramda';

export const selectCurrentTravelEncounters = pipe(
  selectLastTravel,
  prop('encounters'),
);
